
import './vendor/jquery';
import './vendor/popper';
import './vendor/bootstrap';
import './vendor/jquery_modules';

import Swiper, { Pagination, Autoplay, Navigation } from 'swiper';

Swiper.use([
	Navigation,
	Pagination,
	Autoplay
]);

window.Swiper = Swiper; 